<ng-template #requiredStar let-control="control">
  <span *ngIf="(control?.validator | asFunction)({})?.required">*</span>
</ng-template>

<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.name" [term]="t" class="text-wrap"></ngb-highlight>
</ng-template>

<div>
  <div class="row">
    <ng-container *ngIf="'Sanakey/Zertifikate'; let key">
      <div *ngIf="visibleKeys[key]" class="col-12 form-group">
        <div class="position-relative">
          <div
            *ngFor="let vm of $any(zertifikateForm.controls); index as i"
            class="col-12 row remove-last-hr"
          >
            <div class="col-5 col-sm-6 d-flex align-items-end">
              <div class="form-group w-100">
                <label class="">Zertfikatstyp:</label>
                <div class="position-relative">
                  <input
                    #vn
                    (change)="addEmptyZertifikatRow(!vn.value)"
                    (focus)="
                      $any(vm.controls[0]).controlFocused$.next(
                        $any($event).target.name
                      )
                    "
                    (keyup)="addEmptyZertifikatRow(!vn.value)"
                    (selectItem)="addEmptyZertifikatRow(!vn.value)"
                    [formControl]="vm.controls[0]"
                    [inputFormatter]="formatter"
                    [ngbTypeahead]="$any(vm.controls[0]).auswahl"
                    [resultTemplate]="rt"
                    autocomplete="off"
                    class="form-control form-select"
                    container="form"
                    type="text"
                  />
                  <span
                    [ngClass]="{ visible: processingData[key] }"
                    class="loading-icon"
                  >
                    <fa-icon
                      [icon]="loadingIcon"
                      animation="spin-pulse"
                    ></fa-icon>
                  </span>
                </div>
                <san-form-input-error
                  [visible]="vm.controls[0].dirty && !vm.controls[0].value.name"
                  message="Bitte einen Eintrag aus der Liste wählen"
                ></san-form-input-error>
              </div>
            </div>
            <div class="col-5">
              <div class="form-group">
                <label>Zertifikat (Datei):</label>
                <div class="position-relative">
                  <input
                    #thefile
                    (change)="setFileValue(vm.controls[1].controls[0], $event)"
                    [hidden]="true"
                    accept="application/pdf"
                    type="file"
                  />
                  <div class="btn-group">
                    <button
                      (click)="thefile.click()"
                      *ngIf="!vm.controls[1].controls[2].value"
                      class="btn btn-primary"
                    >
                      <span *ngIf="vm.controls[1].controls[0].value"
                      >Datei ausgewählt</span
                      >
                      <span *ngIf="!vm.controls[1].controls[0].value"
                      >Datei wählen</span
                      >
                    </button>
                    <button
                      (click)="thefile.click()"
                      *ngIf="vm.controls[1].controls[2].value"
                      class="btn btn-warning"
                    >
                      <span *ngIf="vm.controls[1].controls[0].value"
                      >Datei ausgewählt</span
                      >
                      <span *ngIf="!vm.controls[1].controls[0].value"
                      >Datei ändern</span
                      >
                    </button>
                    <button
                      (click)="downloadZertifikat(i)"
                      *ngIf="vm.controls[1].controls[2].value"
                      class="btn btn-primary"
                    >
                      Datei herunterladen
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-2 col-sm-1 d-flex align-items-end justify-content-end"
            >
              <div class="float-right form-group">
                <a
                  (click)="deleteZertifikatEintrag($event, i)"
                  [class.disabled]="!vn.value"
                  class="btn btn-outline-warning"
                >
                  <fa-icon [icon]="deleteVerbandIcon"></fa-icon>
                </a>
              </div>
            </div>
            <div class="col-12">
              <label class="">Bemerkungen:</label>
              <textarea
                [formControl]="vm.controls[1].controls[1]"
                class="form-control"
                placeholder="Bemerkungen und Hinweise (optional)"
              ></textarea>
            </div>
            <div class="col-12">
              <hr/>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <san-form-input-error
    [visible]="gotError"
    message="Die Zertifikate konnten nicht aktualisiert werden"
  ></san-form-input-error>
</div>
